import { RichTextRenderer } from "~/components/RichTextRenderer";
import { cn } from "~/lib/utils";

export const HeadlineText = ({
  headline,
  text,
  titleAlign = "left",
}: {
  headline: string;
  text: string;
  titleAlign?: "left" | "center";
}) => {
  return (
    <div>
      {headline ? (
        <h2
          className={cn(
            "text-3xl sm:text-4xl font-semibold mb-4",
            titleAlign === "center" ? "text-center" : "text-left"
          )}
        >
          {headline}
        </h2>
      ) : null}

      <div
        className={cn(titleAlign === "center" ? "text-center" : "text-left")}
      >
        {text ? <RichTextRenderer richText={text} /> : null}
      </div>
    </div>
  );
};
